import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'roundToFloor'})
export class RoundPipe implements PipeTransform {
  transform (input:number) {
    return Math.floor(input);
  }
}